<template>
  <v-card flat
          tile>
    <v-toolbar color="secondary"
               dark
               flat>
      <v-toolbar-title>{{ $t('manualProducts') }}</v-toolbar-title>
      <v-spacer />
      <v-btn text
             v-on:click="dialog = true">
        <v-icon left>mdi-plus</v-icon>
        {{ $t('add') }}
      </v-btn>
    </v-toolbar>
    <v-data-table item-key="key"
                  v-bind:footer-props="{ itemsPerPageOptions: [ 5, 10, 30, 50, 100, -1 ] }"
                  v-bind:headers="headers"
                  v-bind:items="products"
                  v-bind:items-per-page="50">
      <template v-slot:item.count="props">
        <v-edit-dialog v-bind:return-value.sync="props.item.count">
          <div>{{ props.item.count }}</div>
          <template v-slot:input>
            <v-text-field v-model.number="props.item.count"
                          type="number"
                          flat
                          hide-details="auto"
                          solo
                          autofocus />
          </template>
        </v-edit-dialog>
      </template>
      <template v-slot:[`item.productId`]="{ item }">
        <span v-if="item.productId">{{ item.productId }}</span>
        <span v-else>-</span>
      </template>
      <template v-slot:[`item.label`]="{ item }">
        {{ labelText(item.label) }}
      </template>
      <template v-slot:[`item.quantity`]="{ item }">
        <span v-if="item.quantity > 0">{{ item.quantity }}</span>
        <span v-else>-</span>
      </template>
      <template v-slot:[`item.depositBaseUnit`]="{ item }">
        {{ item.depositBaseUnit | formatCurrencyValue }}
      </template>
      <template v-slot:[`item.price`]="{ item }">
        {{ item.price | formatCurrencyValue }}
      </template>
      <template v-slot:[`item.actions`]="{ item }">
        <delete-confirmation-button v-bind:item="item"
                                    v-on:delete="deleteItem($event.key)" />
      </template>
    </v-data-table>
    <v-divider />
    <v-card-actions>
      <v-spacer />
      <clear-list-button v-bind:disabled="!products.length"
                         v-on:clear="clearItems" />
      <v-btn color="accent"
             text
             v-bind:disabled="!products.length"
             v-bind:loading="loading"
             v-on:click="$emit('print')">
        {{ $t('print') }}
      </v-btn>
    </v-card-actions>
    <manual-price-tag-dialog v-model="dialog"
                             v-on:add="addProduct" />
  </v-card>
</template>

<script>
  import DeleteConfirmationButton from '@/components/common/DeleteConfirmationButton.vue'
  import ClearListButton from '@/components/common/ClearListButton.vue'
  import ManualPriceTagDialog from '@/components/price-tag/ManualPriceTagDialog.vue'

  // Manuell angelegte Preisschilder leben nur im Speicher der Seite: kein Store, keine API, keine Datenbank.
  export default {
    components: {
      DeleteConfirmationButton,
      ClearListButton,
      ManualPriceTagDialog
    },
    computed: {
      headers() {
        return [
          {
            text: this.$t('count'),
            value: 'count'
          },
          {
            text: this.$t('number'),
            value: 'productId'
          },
          {
            text: this.$t('title'),
            value: 'publicTitle'
          },
          {
            text: this.$t('label'),
            value: 'label'
          },
          {
            text: this.$t('bottlesPerBundle'),
            value: 'quantity'
          },
          {
            text: this.$t('depositPerBottle'),
            value: 'depositBaseUnit'
          },
          {
            text: this.$t('price'),
            value: 'price'
          },
          {
            sortable: false,
            value: 'actions',
            width: '96px'
          }
        ]
      }
    },
    data: () => ({
      dialog: false
    }),
    methods: {
      labelText(label) {
        if (label === 'MEHRWEG') return this.$t('labelMehrweg')
        if (label === 'EINWEG') return this.$t('labelEinweg')

        return '-'
      },
      addProduct(product) {
        this.products.push(product)
      },
      deleteItem(key) {
        const index = this.products.findIndex(p => p.key === key)

        if (index >= 0) {
          this.products.splice(index, 1)
        }
      },
      clearItems() {
        this.products.splice(0, this.products.length)
      }
    },
    name: 'ManualPriceTagTableCard',
    props: {
      products: Array,
      loading: Boolean
    }
  }
</script>

<i18n>
  {
    "de": {
      "manualProducts": "Manuelle Preisschilder",
      "title": "Bezeichnung",
      "price": "Preis",
      "count": "Anzahl",
      "number": "Nummer",
      "label": "Mehrweg / Einweg",
      "labelMehrweg": "Mehrweg",
      "labelEinweg": "Einweg",
      "bottlesPerBundle": "Fl. / Gebinde",
      "depositPerBottle": "Pfand / Fl.",
      "add": "Hinzufügen",
      "print": "Drucken"
    },
    "en": {
      "manualProducts": "Manual price tags",
      "title": "Title",
      "price": "Price",
      "count": "Count",
      "number": "Number",
      "label": "Reusable / disposable",
      "labelMehrweg": "Mehrweg",
      "labelEinweg": "Einweg",
      "bottlesPerBundle": "Bottles / bundle",
      "depositPerBottle": "Deposit / bottle",
      "add": "Add",
      "print": "Print"
    }
  }
</i18n>
